// extracted by mini-css-extract-plugin
module.exports = {"efaxOrdersLabel":"InboxSidebar_efaxOrdersLabel__3PZFQ","unassignedEfaxes":"InboxSidebar_unassignedEfaxes__2lGq-"};